namespace TabAurous.OMS {
    export interface SergenConnection {
        Key?: string;
    }
}
